import { Container } from '@/components/Container';
import styles from './Loading.module.css';

export const LoadingSpinner = ({ white = false }) => {
  return (
    <Container
      sx={{
        flexGrow: 1,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        opacity: 0.65,
        filter: white ? 'invert(1)' : undefined,
      }}
    >
      <span style={{}} className={styles.loader}></span>
    </Container>
  );
};
